export const drugStoreSteps = [
    {
        step: 1,
        label: "Store Information",
        component: "store-info",
        holder: "storeInfo"
    },
    {
        step: 2,
        label: "Personal Information",
        component: "personal-info",
        holder: "personalInfo"
    },
    {
        step: 3,
        label: "Store Schedule",
        component: "schedule-details",
        holder: "scheduleInfo"
    },
    {
        step: 4,
        label: "In Charge Personel",
        component: "personel-details",
        holder: "personelInCharge",
        showSkipButton: true,
        isPharmacist: true
    },
    {
        step: 5,
        label: "Assistant Personel",
        component: "personel-details",
        holder: "personelAssistant",
        showSkipButton: true,
        isPharmacist: false
    },
    {
        step: 6,
        label: "Uploads Document",
        component: "document-details",
        holder: "documentDetails"
    }
]
    
export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
export const App_Url = process.env.MIX_AWS_URL + '/';
export const Base_Url = process.env.MIX_APP_URL + '/';
export const App_Name = process.env.MIX_APP_NAME;
export const Valid_Resendable_Codes = ['PPD500', 'GR004', 'GR008', 'GR023', 'GR027', 'GR040', 'RM003']
export const CURRENCY = 'PHP ';
export const Publication_Edition = window.PUBLICATION_EDITION;
export const GSM_CHARACTERS = window.GSM_CHARACTERS;
export const TFV_Url = process.env.MIX_TFV_WEB_URL;
export const TINYMCE_API_KEY = "oroj93qogyhbevyzj8jyl3xcwoz4qmm61gkcxmvwsrhfjz5o"; //"1vy2bjqc0j2vvrxkexfqqfxc4fp2ne2e4js5j8yabj5ngw54";
export const IMAGE_DIMENSION_LIMIT = 1900;

//ANNOUNCEMENT
export const POPULATE_RECIPIENT_LIMIT_PER_JOB = window.POPULATE_RECIPIENT_LIMIT_PER_JOB ?? 2000;
export const POPULATE_RECIPIENT_LIMIT_IN_SEC = 120;
export const SEND_RECIPIENT_LIMIT = 1000;
export const SEND_RECIPIENT_LIMIT_IN_SEC = 2;

export const DEFAULT_PERMISSION = {
    CAN_DELETE: 'delete information',
    CAN_EDIT: 'edit information',
    CAN_ADD: 'add information',
    CAN_VIEW: 'view information',
    CAN_APPROVE: 'approve information',
    CAN_DISBURSEMENT: 'disbursement information',
    CAN_VIEW_CONSULTATION: 'consultation information',
    CAN_VIEW_PRESCRIPTION: 'prescription information',
    CAN_VIEW_DIAGNOSTIC: 'diagnostic prescription information',
    CAN_VIEW_MED_CERT: 'medical certificate information',
    CAN_RESEND_CONSENT: 'resend consent information',
    CAN_VIEW_DISCOUNT: 'purchase discount information',
    CAN_VIEW_PRC_IMAGE: 'prc information',
    CAN_VIEW_SIGNATURE: 'signature information',
    CAN_VIEW_PIN: 'pin information',
    CAN_VIEW_TRANSACTION: 'transaction information',
    CAN_UPDATE: 'update information',
    CAN_CREATE: 'create information',
}

export const STATUS = {
    ACTIVATED: 'activated',
    PENDING: 'pending',
    APPROVED: 'approved',
    DECLINED: 'declined',
    CANCELLED: 'cancelled',
    EXPIRED: 'expired',
    PAID: 'paid',
    UNPAID: 'unpaid',
    REFUNDED: 'refunded',
    DELETED: 'deleted',
    FAILED: 'failed',
    DONE: 'done',
    SENT: 'sent',
    QUEUED: 'queued',
    BOUNCED: 'bounced',
    TRANSACTION_PENDING: 'transaction_pending',
    FOR_APPROVAL: 'for approval',
    ACCEPTED: 'accepted',
    SERVED: 'served',
    ON_GOING: 'on_going',
    SUSPENDED: 'suspended',
    ON_HOLD: 'on-hold',
    RESCHEDULE: 'reschedule',
    ACTIVE: 'active',
    INACTIVE: 'inactive',
}

export const PAGINATION = {
    PAGEOPTIONS: [10, 20, 50, 100]
}

export const DRUG_INTERACTION = {
    TYPES: [
        { value: "1", text: "Generic to Generic Interaction" },
        { value: "2", text: "Generic to Section Interaction" },
        { value: "3", text: "Generic to Food Interaction" },
        { value: "4", text: "Section to Section Interaction" },
        { value: "5", text: "Section to Food Interaction" },
        { value: "6", text: "Drug Class to Drug Class Interaction" },
        { value: "7", text: "Drug Class to Generic Interaction" },
        { value: "8", text: "Drug Class to Section Interaction" },
        { value: "9", text: "Drug Class to Food Interaction" }
    ],
    CATEGORIES: [
        { value: "1", text: "Minor" },
        { value: "2", text: "Moderate" },
        { value: "3", text: "Major" }
    ]

}

export const DIRECTORY_TYPE = [
    { value: "generic", text: "Generic" },
    { value: "company", text: "Company" },
    { value: "therapeutic_class", text: "Therapeutic Class" },
    { value: "disease", text: "Disease" },
    { value: "brand", text: "Brand" },
    { value: "device", text: "Device" }
]

export const BRAND_STATUS = [
        { value: 1, text: "Full Listing + ERX" },
        { value: 2, text: "Print Only + ERX" },
        { value: 3, text: "Digital Only + ERX" },
        { value: 4, text: "Unpaid + ERX" },
        { value: 5, text: "Delisted" },
        { value: 6, text: "Phase-Out" },
        { value: 7, text: "Full Listing" },
        { value: 8, text: "Print Only" },
        { value: 9, text: "Digital Only" },
        { value: 10, text: "Unpaid" },
        { value: 11, text: "ERX Only" }
];

export const BRAND_STATUS_FOR_PRINT = [1, 2, 7, 8];
export const BRAND_STATUS_FOR_DIGITAL = [1, 3, 7, 9];
export const BRAND_STATUS_FOR_ACTIVE_BRANDS = [1, 2, 3, 7, 8, 9];

export const ORDER_STATUS = [
    { value: "failed", text: "Failed", background: "#F50E15", color: "text-white", sequence: 0},
    { value: "pending_payment", text: "Pending Payment", background: "#676767", color: "text-white", sequence: 0},
    { value: "pending", text: "Pending", background: "#676767", color: "text-white", sequence: 0},
    { value: "paid", text: "To Prepare", background: "#F8A812", color: "text-white", sequence: 1 },
    { value: "preparing", text: "Preparing", background: "#F87312", color: "text-white", sequence: 2 },
    { value: "in-transit", text: "In-Transit", background: "#3399FF", color: "text-white", sequence: 3 },
    { value: "to-receive", text: "To Receive", background: "#321FDB", color: "text-white", sequence: 4 },
    { value: "completed", text: "Completed", background: "#2EB85C", color: "text-white", sequence: 5 },
    { value: "cancelled", text: "Cancelled", background: "#d44950", color: "text-white", sequence: 6},
    { value: "all", text: "All", background: "#EBEDEF", color: "text-dark", sequence: 0 },
];

export const DAYS = [
    { value: 1, text: "Monday" },
    { value: 2, text: "Tuesday" },
    { value: 3, text: "Wednesday" },
    { value: 4, text: "Thursday" },
    { value: 5, text: "Friday" },
    { value: 6, text: "Saturday" },
    { value: 7, text: "Sunday" }
];

export const USER_TYPES = [
    { value: null, text: "All" },
    { value: "vet", text: "Vet" },
    { value: "para_vet", text: "Para Vet" },
    { value: "business_owner", text: "Business Owner" },
    { value: "pet_owner", text: "Pet Owner" }
];

export const DEFAULT_OPTIONS = [
    { value: null, text: "All" },
    { value: 1, text: "Yes" },
    { value: 0, text: "No" }
]

export const COMPANY_LISTING_TYPE_OPTIONS = [
    { value: "basic", text: "Basic Only", color: "info" },
    // { value: "logo", text: "Bold Listing with Logo", color: "primary" },
    { value: "bold_company", text: "Bold Company Name with Logo", color: "secondary" },
    { value: "profile", text: "Bold Listing with Company Profile", color: "success" },
]

export const SORT_OPTIONS = [
    { value: "asc", text: "Asc" },
    { value: "desc", text: "Desc" }
]

export const LIMIT_OPTIONS = [
    { value: 10, text: "10" },
    { value: 20, text: "20" },
    { value: 50, text: "50" },
    { value: 100, text: "100" }
]

export const DOCTOR = {
    STATUS: [
        { value: "approved", text: "Approved" },              
        { value: "pending", text: "Pending" },        
        { value: "declined", text: "Declined" },
        { value: "for approval", text: "For Approval" },            
        { value: "for deletion", text: "For Deletion" }
    ],
    PRESCRIBED_STATUS: [
        { value: "approved", text: "Approved" },              
        { value: "pending", text: "Pending" },        
        { value: "declined", text: "Declined" },
        { value: "suspended", text: "Suspended" }
    ],
};

export const ADVERTISEMENT = {
    TYPES: [
        { value: "foot_ad", text: "Footer Ads" },
        { value: "head_ad", text: "Header Ads" },
        { value: "title_ad", text: "Title Ads" },
        { value: "default", text: "Default" },
        { value: "marketplace", text: "Marketplace" },
        { value: "spotlight", text: "Spotlight" },
        { value: "health_answer", text: "Health Answer" },
        { value: "billboard1", text: "Billboard1" },
        { value: "billboard2", text: "Billboard2" },
        { value: "youtube", text: "Youtube" },
        { value: "splash_ad", text: "Splash Ad" },
        { value: "cpm_half_banner", text: "CPM Half Banner" },
        { value: "middle_banner", text: "Middle Banner" },
        { value: "billboard3", text: "Billboard3" }
    ],
    PLATFORMS: [
        { value: "pvet-clinic", text: "PVET Clinic" },
        { value: "tfv", text: "TheFilipinoVet" }
    ],
    DISPLAYS: [
        { value: "default", text: "Default" },
        { value: "doctor", text: "Doctor" },
        { value: "bmp", text: "BMP" },
    ],
    STATUSES: [
        { value: "pending", text: "Pending" },
        { value: "approved", text: "Approved" },
        { value: "declined", text: "Declined" },
        { value: "cancelled", text: "Cancelled" }
    ]
};

export const ADMETA = {
    KEYS: [
        { value: "page", text: "Page" },
        { value: "keyword", text: "Keyword" },
        { value: "specialty", text: "Specialty" },
        { value: "brand", text: "Brand" },
        { value: "treatment_guideline", text: "Treatment Guideline" }
    ],
    PAGES: [
        { value: "announcement", text: "Announcement" },
        { value: "appointments", text: "Appointments" },
        { value: "brand", text: "Brand" },
        { value: "company", text: "Company" },
        { value: "disease", text: "Disease" },
        { value: "generic", text: "Generic" },
        { value: "therapeutic_class", text: "Therapeutic Class" },
        { value: "transaction", text: "Transaction" },
        { value: "dashboard", text: "Dashboard" },
        { value: "messages", text: "Messages" },
        { value: "patients", text: "Patients" }
    ],
};
